import {
    selectMainState,
    useDispatch,
    useSelector,
} from "../../../stateManagement/redux";
import { login } from "../../../stateManagement/redux/slices/shared/asyncReducers";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CircularProgress,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import "./style.scss";

export const Login = () => {
    const dispatch = useDispatch();

    const mainState = useSelector(selectMainState);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const onLogin = () => {
        dispatch(login(email, password));
    };

    return (
        <Grid
            container
            direction="row"
            sx={{ justifyContent: "center", alignItems: "center" }}
        >
            <Grid
                size={{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <Card
                    sx={{
                        padding: 2,
                    }}
                >
                    <Box>
                        <CardContent>
                            <Box className="wrap-main_login_logo">
                                <Box
                                    component="img"
                                    src="/assets/icons/logo_without_text.svg"
                                />
                                <Box
                                    component="img"
                                    src="/assets/icons/logo_text.svg"
                                />
                            </Box>

                            <Box>
                                <TextField
                                    id="Correo Electrónico"
                                    label="Correo Electrónico"
                                    variant="outlined"
                                    size="small"
                                    value={email}
                                    fullWidth
                                    onChange={(e) => setEmail(e.target.value)}
                                />

                                <FormControl
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    sx={{ marginTop: 2 }}
                                >
                                    <InputLabel htmlFor="outlined-adornment-password">
                                        Contraseña
                                    </InputLabel>
                                    <OutlinedInput
                                        size="small"
                                        label="Contraseña"
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                        id="outlined-adornment-password"
                                        type={
                                            showPassword ? "text" : "password"
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword
                                                            ? "hide the password"
                                                            : "display the password"
                                                    }
                                                    onClick={
                                                        handleClickShowPassword
                                                    }
                                                    edge="end"
                                                >
                                                    {showPassword ? (
                                                        <VisibilityOff />
                                                    ) : (
                                                        <Visibility />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                            </Box>
                        </CardContent>
                        <CardActions>
                            <Button
                                variant="contained"
                                onClick={onLogin}
                                fullWidth
                            >
                                {mainState.loading ? (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                ) : (
                                    "Iniciar Sesión"
                                )}
                            </Button>
                        </CardActions>
                    </Box>
                </Card>
            </Grid>
        </Grid>
    );
};
